import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import { Translate, I18n } from 'react-redux-i18n';
import { Input, Button, Form } from 'reactstrap';
import AuthView from "components/AuthView";
import PageHeader from 'components/PageHeader';
import { updateDocumentTitle } from 'actions';
import SearchResultWrap from 'components/SearchResultWrap';
import headerConfigFor from './ListHeader';
import ListRow from './ListRow';
import ListView from 'components/ListView';
import permissionHandler from 'helpers/permission-handler';
import { AUTH_RETRIEVAL_CHARGEBACK } from 'constants/permission';
import { useLazyGetRetrivalQuery, useCreateChargebackMutation } from 'redux/hook/useCustomer';
import Modal from 'components/Modal';
import CustomForm from 'components/Form';
import TextInput from 'components/Form/Input';

import './retrieval-finder.scss';
import { TYPE_TEXT } from 'components/Form/Input';
import FlexGroup from 'components/FlexGroup';
import { toggleErrorDialog } from 'actions';
import { ERROR_CHARGE_PROCESSING, ERROR_RECORD_NOT_FOUND } from 'constants/retrieval';

const RetrievalFinder = () => {
    const inputEl = useRef();
    const inputChargebackEl = useRef();
    const [searchResultMessage, setSearchResultMessage] = useState('');
    const [retrievalData, setRetrievalData] = useState([]);
    const [show, setShow] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [getRetrival] = useLazyGetRetrivalQuery();
    const [createChargeback] = useCreateChargebackMutation();
    const location = useLocation();
    const dispatch = useDispatch();
    const i18n = useSelector(state => state.i18n);

    const header = headerConfigFor(permissionHandler({
        requiredList: [AUTH_RETRIEVAL_CHARGEBACK]
    }));

    useEffect(() => {
        const { pathname } = location;
        dispatch(updateDocumentTitle(`routes.${ pathname }`));
        // eslint-disable-next-line
    }, []);

    useEffect(() => {

    }, [i18n]);

    const ListItem = ({ columns, rowData }) => {
        return (
            <ListRow
                key={ `retrival-${ rowData.order_id }` }
                onClick = { () => { setShow(true) } }
                columns={ columns }
                data={ rowData }
            />
        )
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const { data, error } = await getRetrival({ order_id: inputEl.current.value });
        if (error) {
            setSearchResultMessage(I18n.t('general_error_message'));
            return;
        }
        const { data_list } = data;
        setRetrievalData(data_list);
    }

    const handleChargebackSubmit = async () => {
        const { transaction_record, transaction_type } = retrievalData[0];
        setIsSubmitting(true);
        // dispatch chargeback action
        const { error: createError } = await createChargeback({
            transaction_record,
            transaction_type,
            order_id: inputChargebackEl.current.value
        });
        if (createError) {
            const { code } = createError?.data || {};
            const message = (code !== undefined
                && (code === ERROR_CHARGE_PROCESSING || code === ERROR_RECORD_NOT_FOUND)
            ) ? I18n.t(`retrieval.chargeback_error_${ code }`) : I18n.t('general_error_message');
            dispatch(toggleErrorDialog(message));
            setIsSubmitting(false);
            return;
        }
        const { data, error } = await getRetrival({ order_id: inputEl.current.value });
        if (error) {
            setSearchResultMessage(I18n.t('general_error_message'));
            return;
        }
        const { data_list } = data;
        setRetrievalData(data_list);
        setIsSubmitting(false);
        setShow(false);
    }

    const handleClose = () => {
        setShow(false)
        setIsSubmitting(false);
    };

    return (
        <AuthView className="retrieval-finder">
            <PageHeader>
                <Translate value="retrieval.retrieval_finder" />
            </PageHeader>
            <Form className="filter" onSubmit={ handleSubmit }>
                <Input className="search-text" innerRef={ inputEl } placeholder={ I18n.t('retrieval.order_id') } type="text" />
                <Button type="submit">
                    <Translate value="search" />
                </Button>
            </Form>
            <SearchResultWrap
                show={ retrievalData?.length !== 0 }
                message={ searchResultMessage }
            >
                <ListView
                    rowHeight={ 56 }
                    header={ header }
                    list={ retrievalData }
                    renderListRow={ ListItem }
                    dataKey="order_id"
                />
            </SearchResultWrap>
            {
                show && (
                    <Modal
                        className="chargeback_modal"
                        title={ I18n.t('retrieval.chargeback') }
                        onClose={ handleClose }
                    >
                        <CustomForm onSubmit={ handleChargebackSubmit } inProgress={ isSubmitting }>
                            <TextInput
                                name="order_id"
                                innerRef={ inputChargebackEl }
                                type={ TYPE_TEXT }
                                caption="retrieval.order_id"
                                required
                            />
                            <FlexGroup end gap>
                                <Button
                                    type="button"
                                    className="btn-cancel"
                                    onClick={ handleClose }
                                    disabled={ isSubmitting }
                                    outline
                                >
                                    <Translate value="cancel" />
                                </Button>
                                <Button color="primary" type="submit" disabled={ isSubmitting }>
                                    <Translate value="submit" />
                                </Button>
                            </FlexGroup>
                        </CustomForm>
                    </Modal>
                )
            }
        </AuthView>
    )
}

export default RetrievalFinder;
